import Register from './components/Register'
import SignatureList from './components/SignatureList'

import apConfig from "@config/88.json"
if (apConfig.actionpage && apConfig.template && apConfig.template == true) { apConfig.actionpage = null; }
export const config = apConfig
export const steps = {Register,SignatureList}

export const portals = {SignatureList}

